import Link from "./link-styled";
export { BaseStyledLink } from "./link-styled";
export default Link;
